import * as orderItemsActions from '../actions/orderItems';
import * as fetchingState from '../constants/fetchingState';
import { getErrorMessage } from '../constants/errorCode';

export default function(orders, action) {
    switch (action.type) {
        case orderItemsActions.FETCH_ORDER_ITEMS:
            {
                return updateOrder(orders, action.orderId, { itemsFetching: fetchingState.FETCHING,error: undefined });
            }
        case orderItemsActions.SUCCESS_FETCH_ORDER_ITEMS:
            {
                if (!action.data.error) {
                    action.data.forEach(i => i.FullName = `${i.Service} (${i.Price} р.)`);
                    return updateOrder(orders, action.orderId, { itemsFetching: fetchingState.FETCHED, Items: action.data, error: undefined });
                }
                return updateOrder(orders, action.orderId, { itemsFetching: fetchingState.FAILED, Items: [], error: getErrorMessage(action.data.error) });
            }
        case orderItemsActions.FAILURE_FETCH_ORDER_ITEMS:
            {
                return updateOrder(orders, action.orderId, { itemsFetching: fetchingState.FAILED, Items: [], error: getErrorMessage(action.data.error) });
            }
        default:
            return orders;
    }
}

const updateOrder = (ordersSource, id, updatedOrder) => {
    const orders = [...ordersSource];
    const orderIndex = orders.findIndex(o => o.Id === id);
    orders[orderIndex] = {...orders[orderIndex], ...updatedOrder };
    return orders;
}


// WEBPACK FOOTER //
// ./src/reducers/orderItemsReducer.js